import { HTMLAttributes } from 'react';
import { type VariantProps } from 'class-variance-authority';
import { badgeVariants } from './badgeVariants';
import { cn } from '@shared/lib';

export type BadgeProps = HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof badgeVariants>;

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge };
